<template>
  <px-custom-dialog v-model="dialog" content-class="rounded-card" width="1280">
    <template v-slot:activator="{ on }">
      <v-btn icon
             v-on="on">
        <v-icon>mdi-eye</v-icon>
      </v-btn>
    </template>
    <template v-slot:title>
      Aprovação
      <v-btn class="ml-3" icon link target="_blank" :to="linkAprovacao">
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn>
    </template>
    <template>
      <px-aprovacao-detalhes is-modal-view
                          :aprovacao-id-prop="aprovacaoId"/>
    </template>
  </px-custom-dialog>
</template>

<script>
import AprovacaoDetalhes from '@/modules/aprovacao/detalhes/AprovacaoDetalhes.vue';

export default {
  props: {
    aprovacaoId: {
      type: [String, Number],
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    linkAprovacao() {
      return `/aprovacao/${this.aprovacaoId}`;
    },
  },
  components: {
    pxAprovacaoDetalhes: AprovacaoDetalhes,
  },
};
</script>
